import { __assign } from 'tslib';
import { isSVGComponent } from './utils/is-svg-component.js';
import { createElement } from 'react';
import { useHTMLProps } from './utils/use-html-props.js';
import { filterProps } from './utils/filter-props.js';
import { useSVGProps } from './utils/use-svg-props.js';

function createUseRender(Component, forwardMotionProps) {
    if (forwardMotionProps === void 0) { forwardMotionProps = false; }
    var useRender = function (props, visualElement) {
        // Generate props to visually render this component
        var useProps = isSVGComponent(Component) ? useSVGProps : useHTMLProps;
        var visualProps = useProps(visualElement, props);
        return createElement(Component, __assign(__assign(__assign({}, filterProps(props, typeof Component === "string", forwardMotionProps)), { ref: visualElement.ref }), visualProps));
    };
    return useRender;
}

export { createUseRender };
